export const activityHistoryMessages = {
  en: {
    title: 'History',
    // The label under the history icon in the bottom bar: one short word, so it is never cut off.
    tab: 'History',
    description: 'What you have done, including finished or cancelled jobs.',
    today: 'Today',
    yesterday: 'Yesterday',
    search: 'Parcel or collection reference',
    dates: 'Period',
    from: 'From',
    to: 'To',
    apply: 'Apply',
    reset: 'Clear all',
    dateError: 'The end date cannot be before the start date.',
    empty: 'Nothing yet',
    emptyHint: 'What you do will show here.',
    noResults: 'Nothing matches',
    noResultsHint: 'Try another reference or clear the filters.',
    loadFailed: 'Could not load your history.',
    retry: 'Try again',
    refresh: 'Refresh',
    total: '{count} actions',
    summary: 'Details',
    record: 'Reference',
    type: 'Type',
    when: 'Date and time',
    before: 'Before',
    after: 'After',
    parcels: 'Parcels in this collection',
    openRecord: 'Open',
    readOnly:
      'This action stays in your history. You can open the parcel as long as you have access to it.',
    unavailable: 'Not found',
    batch: 'Several parcels',
    categories: {
      all: 'All',
      parcels: 'Parcels',
      drops: 'Drop-offs',
      pickups: 'Collections',
      returns: 'Returns',
      other: 'Other'
    },
    actions: {
      parcelCreated: 'Parcel created',
      parcelsImported: 'Parcels added from a file',
      agentChanged: 'Agent changed',
      codeResent: 'Code sent again',
      pickupCreated: 'Collection prepared',
      pickupAssigned: 'Collection given to a courier',
      pickupAccepted: 'Collection accepted',
      pickupReleased: 'Collection cancelled',
      pickupReceived: 'Collection done',
      codeRefreshed: 'New code created',
      dropCreated: 'Drop-off prepared',
      dropReceived: 'Drop-off received',
      returnAccepted: 'Return accepted',
      returnReleased: 'Return cancelled',
      customerHandover: 'Parcel received from the customer',
      handoverConfirmed: 'Hand-over confirmed',
      handoverReady: 'Hand-over ready',
      senderReturn: 'Given back to the sender',
      originReturn: 'Given back at the starting point',
      returnPointAssigned: 'Return point chosen',
      incidentReported: 'Return problem reported',
      incidentResolved: 'Return problem solved',
      workReassigned: 'Job given to someone else',
      returnApproved: 'Return request accepted',
      returnRejected: 'Return request refused',
      cancellationApproved: 'Cancellation accepted',
      cancellationRejected: 'Cancellation refused',
      cancellationCompleted: 'Cancellation done',
      requestAccepted: 'Customer request accepted',
      requestDeclined: 'Customer request refused',
      withdrawalRequested: 'Withdrawal requested',
      recorded: 'Action recorded'
    }
  },
  fr: {
    title: 'Historique',
    // The label under the history icon in the bottom bar: one short word, so it is never cut off.
    tab: 'Historique',
    description: 'Ce que vous avez fait, y compris les missions terminées ou annulées.',
    today: 'Aujourd’hui',
    yesterday: 'Hier',
    search: 'Référence d’un colis ou d’une collecte',
    dates: 'Période',
    from: 'Du',
    to: 'Au',
    apply: 'Appliquer',
    reset: 'Tout effacer',
    dateError: 'La date de fin ne peut pas être avant la date de début.',
    empty: 'Rien pour l’instant',
    emptyHint: 'Ce que vous faites apparaîtra ici.',
    noResults: 'Rien ne correspond',
    noResultsHint: 'Essayez une autre référence ou effacez les filtres.',
    loadFailed: 'Impossible de charger votre historique.',
    retry: 'Réessayer',
    refresh: 'Actualiser',
    total: '{count} actions',
    summary: 'Détails',
    record: 'Référence',
    type: 'Type',
    when: 'Date et heure',
    before: 'Avant',
    after: 'Après',
    parcels: 'Colis de cette collecte',
    openRecord: 'Ouvrir',
    readOnly:
      'Cette action reste dans votre historique. Vous pouvez ouvrir le colis tant que vous y avez accès.',
    unavailable: 'Introuvable',
    batch: 'Plusieurs colis',
    categories: {
      all: 'Tout',
      parcels: 'Colis',
      drops: 'Dépôts',
      pickups: 'Collectes',
      returns: 'Retours',
      other: 'Autres'
    },
    actions: {
      parcelCreated: 'Colis créé',
      parcelsImported: 'Colis ajoutés par fichier',
      agentChanged: 'Agent changé',
      codeResent: 'Code renvoyé',
      pickupCreated: 'Collecte préparée',
      pickupAssigned: 'Collecte confiée à un livreur',
      pickupAccepted: 'Collecte acceptée',
      pickupReleased: 'Collecte annulée',
      pickupReceived: 'Collecte terminée',
      codeRefreshed: 'Nouveau code créé',
      dropCreated: 'Dépôt préparé',
      dropReceived: 'Dépôt reçu',
      returnAccepted: 'Retour accepté',
      returnReleased: 'Retour annulé',
      customerHandover: 'Colis reçu du client',
      handoverConfirmed: 'Remise confirmée',
      handoverReady: 'Remise prête',
      senderReturn: 'Rendu à l’expéditeur',
      originReturn: 'Rendu au point de départ',
      returnPointAssigned: 'Point de retour choisi',
      incidentReported: 'Problème de retour signalé',
      incidentResolved: 'Problème de retour réglé',
      workReassigned: 'Mission confiée à un autre',
      returnApproved: 'Demande de retour acceptée',
      returnRejected: 'Demande de retour refusée',
      cancellationApproved: 'Annulation acceptée',
      cancellationRejected: 'Annulation refusée',
      cancellationCompleted: 'Annulation terminée',
      requestAccepted: 'Demande du client acceptée',
      requestDeclined: 'Demande du client refusée',
      withdrawalRequested: 'Retrait demandé',
      recorded: 'Action enregistrée'
    }
  },
  ar: {
    title: 'السجل',
    // The label under the history icon in the bottom bar: one short word, so it is never cut off.
    tab: 'السجل',
    description: 'ما قمت به، بما في ذلك المهام المنتهية أو الملغاة.',
    today: 'اليوم',
    yesterday: 'أمس',
    search: 'مرجع الطرد أو عملية الجمع',
    dates: 'الفترة',
    from: 'من',
    to: 'إلى',
    apply: 'تطبيق',
    reset: 'مسح الكل',
    dateError: 'لا يمكن أن يكون تاريخ النهاية قبل تاريخ البداية.',
    empty: 'لا شيء بعد',
    emptyHint: 'ما تقوم به سيظهر هنا.',
    noResults: 'لا شيء مطابق',
    noResultsHint: 'جرب مرجعا آخر أو امسح التصفية.',
    loadFailed: 'تعذر تحميل سجلك.',
    retry: 'حاول مرة أخرى',
    refresh: 'تحديث',
    total: '{count} إجراءات',
    summary: 'التفاصيل',
    record: 'المرجع',
    type: 'النوع',
    when: 'التاريخ والوقت',
    before: 'قبل',
    after: 'بعد',
    parcels: 'طرود هذه العملية',
    openRecord: 'فتح',
    readOnly: 'يبقى هذا الإجراء في سجلك. يمكنك فتح الطرد ما دمت تملك صلاحية الوصول.',
    unavailable: 'غير موجود',
    batch: 'عدة طرود',
    categories: {
      all: 'الكل',
      parcels: 'الطرود',
      drops: 'التسليمات',
      pickups: 'عمليات الجمع',
      returns: 'الإرجاعات',
      other: 'أخرى'
    },
    actions: {
      parcelCreated: 'تم إنشاء الطرد',
      parcelsImported: 'أُضيفت طرود من ملف',
      agentChanged: 'تم تغيير الوكيل',
      codeResent: 'أُعيد إرسال الرمز',
      pickupCreated: 'تم تجهيز عملية جمع',
      pickupAssigned: 'أُسندت عملية الجمع لموزّع',
      pickupAccepted: 'تم قبول الجمع',
      pickupReleased: 'تم إلغاء الجمع',
      pickupReceived: 'تم الجمع',
      codeRefreshed: 'تم إنشاء رمز جديد',
      dropCreated: 'تم تجهيز تسليم',
      dropReceived: 'تم استلام التسليم',
      returnAccepted: 'تم قبول الإرجاع',
      returnReleased: 'تم إلغاء الإرجاع',
      customerHandover: 'تم استلام الطرد من الزبون',
      handoverConfirmed: 'تم تأكيد التسليم',
      handoverReady: 'التسليم جاهز',
      senderReturn: 'أُعيد إلى المرسل',
      originReturn: 'أُعيد إلى نقطة الانطلاق',
      returnPointAssigned: 'تم اختيار نقطة الإرجاع',
      incidentReported: 'تم الإبلاغ عن مشكل في الإرجاع',
      incidentResolved: 'تم حل مشكل الإرجاع',
      workReassigned: 'أُسندت المهمة لشخص آخر',
      returnApproved: 'تم قبول طلب الإرجاع',
      returnRejected: 'تم رفض طلب الإرجاع',
      cancellationApproved: 'تم قبول الإلغاء',
      cancellationRejected: 'تم رفض الإلغاء',
      cancellationCompleted: 'تم الإلغاء',
      requestAccepted: 'تم قبول طلب الزبون',
      requestDeclined: 'تم رفض طلب الزبون',
      withdrawalRequested: 'تم طلب السحب',
      recorded: 'تم تسجيل الإجراء'
    }
  },
  ma: {
    title: 'السجل ديالي',
    // The label under the history icon in the bottom bar: one short word, so it is never cut off.
    tab: 'السجل',
    description: 'شنو درتي، حتى المهام اللي سالات ولا تلغات.',
    today: 'اليوم',
    yesterday: 'البارح',
    search: 'مرجع الكولي ولا الجمع',
    dates: 'المدة',
    from: 'من',
    to: 'حتى',
    apply: 'طبق',
    reset: 'مسح الكل',
    dateError: 'تاريخ النهاية ما يمكنش يكون قبل البداية.',
    empty: 'ماكاين والو باقي',
    emptyHint: 'شنو كتدير غادي يبان هنا.',
    noResults: 'ماكاين والو مطابق',
    noResultsHint: 'جرب مرجع آخر ولا مسح الفلتر.',
    loadFailed: 'ما قدرناش نحملو السجل ديالك.',
    retry: 'عاود جرب',
    refresh: 'حدث',
    total: '{count} د العمليات',
    summary: 'التفاصيل',
    record: 'المرجع',
    type: 'النوع',
    when: 'التاريخ والوقت',
    before: 'قبل',
    after: 'من بعد',
    parcels: 'كوليات هاد العملية',
    openRecord: 'حل',
    readOnly:
      'هاد العملية كتبقى فالسجل ديالك. تقدر تحل الكولي ما دام عندك الصلاحية.',
    unavailable: 'ماكاينش',
    batch: 'بزاف د الكوليات',
    categories: {
      all: 'الكل',
      parcels: 'الكوليات',
      drops: 'التسليمات',
      pickups: 'الجمع',
      returns: 'الإرجاعات',
      other: 'أخرى'
    },
    actions: {
      parcelCreated: 'الكولي تصاوب',
      parcelsImported: 'تزادو كوليات من ملف',
      agentChanged: 'الكارديان تبدل',
      codeResent: 'الكود تعاود تصيفط',
      pickupCreated: 'الجمع تواجد',
      pickupAssigned: 'الجمع تعطى لليفرور',
      pickupAccepted: 'الجمع تقبل',
      pickupReleased: 'الجمع تلغى',
      pickupReceived: 'الجمع سالا',
      codeRefreshed: 'كود جديد تصاوب',
      dropCreated: 'التسليم تواجد',
      dropReceived: 'التسليم تستلم',
      returnAccepted: 'الإرجاع تقبل',
      returnReleased: 'الإرجاع تلغى',
      customerHandover: 'تستلم الكولي من الزبون',
      handoverConfirmed: 'التسليم تأكد',
      handoverReady: 'التسليم واجد',
      senderReturn: 'تردّ للمرسل',
      originReturn: 'تردّ لنقطة الانطلاق',
      returnPointAssigned: 'نقطة الإرجاع تختارات',
      incidentReported: 'تبلغ على مشكل فالإرجاع',
      incidentResolved: 'مشكل الإرجاع تحل',
      workReassigned: 'المهمة تعطات لواحد آخر',
      returnApproved: 'طلب الإرجاع تقبل',
      returnRejected: 'طلب الإرجاع ترفض',
      cancellationApproved: 'الإلغاء تقبل',
      cancellationRejected: 'الإلغاء ترفض',
      cancellationCompleted: 'الإلغاء سالا',
      requestAccepted: 'طلب الزبون تقبل',
      requestDeclined: 'طلب الزبون ترفض',
      withdrawalRequested: 'السحب تطلب',
      recorded: 'العملية تسجلات'
    }
  }
}
